import {notification} from 'antd';
import axios from 'axios';
import {useEffect, useRef} from 'react';
import {useHistory} from 'react-router-dom';

import {URL_FORBIDDEN, URL_LOGIN} from 'shared/constants/urls';
import {store} from 'store/config';
import {useAppDispatch, useAppSelector} from 'store/config/hooks';
import {resetStore} from 'store/config/reducers';
import {
    authSliceActions,
    AuthResponseTypes,
    SESSION_EXPIRED_NOTIFICATION,
    AuthErrors,
    selectAuthError,
} from 'store/slices/auth-slice';

export const AxiosInterceptorsInjector = () => {
    const dispatch = useAppDispatch();
    const history = useHistory();
    const {resetToken} = authSliceActions;
    const currentError = useAppSelector(selectAuthError);

    const interceptorId = useRef<number | null>(null);

    useEffect(() => {
        axios.defaults.headers.common['x-react-req-id'] = 1;

        return () => {
            axios.defaults.headers.common['x-react-req-id'] = null;
        };
    }, []);

    useEffect(() => {
        interceptorId.current = axios.interceptors.response.use(
            response => {
                if (currentError && currentError?.code === 403) {
                    dispatch(authSliceActions.resetError());
                }
                return response;
            },
            error => {
                const status = error.response?.status;
                const type = error.response?.data?.type || error.response?.statusText;
                const menuData = store.getState().MENU_SLICE?.structure;

                if (status === 401) {
                    dispatch(resetToken());
                    dispatch(resetStore());
                    notification.info({
                        message: SESSION_EXPIRED_NOTIFICATION.MESSAGE,
                        duration: null,
                        key: SESSION_EXPIRED_NOTIFICATION.KEY,
                        description: SESSION_EXPIRED_NOTIFICATION.DESCRIPTION,
                    });
                    history.push(URL_LOGIN);
                    if (type === AuthResponseTypes.PASSWORD_EXPIRED) {
                        dispatch(authSliceActions.setPasswordExpired(true));
                    }
                }
                if (status === 403) {
                    const isBlobResponseType = error?.config?.responseType === 'blob';
                    if (type === AuthResponseTypes.NEED_2FA) {
                        history.push(URL_FORBIDDEN, {need2FA: true});
                    } else if((!currentError || currentError?.code !== 403)
                        && menuData && !isBlobResponseType) {
                        dispatch(authSliceActions.setError({message: AuthErrors.FORBIDDEN, code: 403}));
                    } else if (!menuData) {
                        history.push(URL_FORBIDDEN);
                    }
                }
                return Promise.reject(error);
            },
        );

        return () => {
            axios.interceptors.response.eject(interceptorId.current as number);
        };
    }, [history]);

    return null;
};
